__turbopack_context__.v({
  "actions": "F8oRHG_actions",
  "card": "F8oRHG_card",
  "cardDescription": "F8oRHG_cardDescription",
  "cardHeader": "F8oRHG_cardHeader",
  "cardTitle": "F8oRHG_cardTitle",
  "emailBlock": "F8oRHG_emailBlock",
  "emailLabel": "F8oRHG_emailLabel",
  "emailValue": "F8oRHG_emailValue",
  "form": "F8oRHG_form",
  "hiddenFileInput": "F8oRHG_hiddenFileInput",
  "intro": "F8oRHG_intro",
  "loadingActionsRow": "F8oRHG_loadingActionsRow",
  "loadingCard": "F8oRHG_loadingCard",
  "loadingCards": "F8oRHG_loadingCards",
  "loadingPhotoRow": "F8oRHG_loadingPhotoRow",
  "nameRow": "F8oRHG_nameRow",
  "photoHint": "F8oRHG_photoHint",
  "photoRow": "F8oRHG_photoRow",
  "profilePanel": "F8oRHG_profilePanel",
});
